(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yazarlar-grid"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initPopularSlider(slider){
    if(!slider||slider.dataset.sliderReady==='true')return;
    slider.dataset.sliderReady='true';
    const track=slider.querySelector('[data-popular-track]');
    const prev=slider.querySelector('[data-popular-prev]');
    const next=slider.querySelector('[data-popular-next]');
    if(!track||!prev||!next)return;

    function updateNavigation(){
      const maxScroll=track.scrollWidth-track.clientWidth;
      const hasOverflow=maxScroll>4;
      slider.classList.toggle('is-static',!hasOverflow);
      if(!hasOverflow){prev.disabled=true;next.disabled=true;return;}
      prev.disabled=track.scrollLeft<=4;
      next.disabled=track.scrollLeft>=maxScroll-4;
    }

    function getScrollStep(){
      const card=track.querySelector('.popular-author');
      if(!card)return track.clientWidth*.8;
      const styles=window.getComputedStyle(track);
      const gap=parseFloat(styles.columnGap)||parseFloat(styles.gap)||20;
      return card.getBoundingClientRect().width+gap;
    }

    prev.addEventListener('click',function(){track.scrollBy({left:-getScrollStep(),behavior:'smooth'});});
    next.addEventListener('click',function(){track.scrollBy({left:getScrollStep(),behavior:'smooth'});});

    let pointerDown=false;
    let isDragging=false;
    let startX=0;
    let startY=0;
    let startScrollLeft=0;
    let activePointerId=null;
    let blockLinkClick=false;
    const DRAG_THRESHOLD=10;

    track.addEventListener('pointerdown',function(event){
      if(event.pointerType==='mouse'&&event.button!==0)return;
      if(event.pointerType!=='mouse')return;
      pointerDown=true;
      isDragging=false;
      blockLinkClick=false;
      activePointerId=event.pointerId;
      startX=event.clientX;
      startY=event.clientY;
      startScrollLeft=track.scrollLeft;
    });

    track.addEventListener('pointermove',function(event){
      if(!pointerDown)return;
      const deltaX=event.clientX-startX;
      const deltaY=event.clientY-startY;
      const distance=Math.sqrt((deltaX*deltaX)+(deltaY*deltaY));
      if(!isDragging){
        if(distance<DRAG_THRESHOLD)return;
        isDragging=true;
        blockLinkClick=true;
        track.classList.add('is-dragging');
        if(track.setPointerCapture){try{track.setPointerCapture(event.pointerId);}catch(error){}}
      }
      event.preventDefault();
      track.scrollLeft=startScrollLeft-deltaX;
    });

    function stopDragging(){
      if(!pointerDown)return;
      pointerDown=false;
      if(isDragging){
        track.classList.remove('is-dragging');
        if(activePointerId!==null&&track.releasePointerCapture&&track.hasPointerCapture){
          try{if(track.hasPointerCapture(activePointerId))track.releasePointerCapture(activePointerId);}catch(error){}
        }
      }
      isDragging=false;
      activePointerId=null;
      if(blockLinkClick){window.setTimeout(function(){blockLinkClick=false;},80);}
    }

    track.addEventListener('pointerup',stopDragging);
    track.addEventListener('pointercancel',stopDragging);

    track.addEventListener('click',function(event){
      const link=event.target.closest('[data-author-link]');
      if(!link)return;
      if(!blockLinkClick)return;
      event.preventDefault();
      event.stopPropagation();
    },true);

    track.addEventListener('dragstart',function(event){event.preventDefault();});

    let scrollFrame=null;
    track.addEventListener('scroll',function(){
      if(scrollFrame)cancelAnimationFrame(scrollFrame);
      scrollFrame=requestAnimationFrame(updateNavigation);
    });

    if('ResizeObserver' in window){
      const observer=new ResizeObserver(updateNavigation);
      observer.observe(track);
    }else{
      window.addEventListener('resize',updateNavigation);
    }

    updateNavigation();
  }

  function initAllPopularSliders(scope){
    const root=scope||document;
    root.querySelectorAll('[data-popular-slider]').forEach(initPopularSlider);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){initAllPopularSliders(document);});
  }else{
    initAllPopularSliders(document);
  }

  document.addEventListener('shopify:section:load',function(event){initAllPopularSliders(event.target);});
})();

  } catch(e) { console.error(e); }
})();
})();
